//import "./ProdutoLoginInfo.css";

export default function ProdutoLoginInfo({
    onLogin,
}) {

    return (
        <>
            <p className="produto-login-info">
                Para visualizar o preço, por favor, faça login na sua conta.
                Caso não tenha uma conta, você pode criar uma gratuitamente em
                nosso site.
            </p>

            <button
                className="botao-preco"
                onClick={onLogin}
            >
                Fazer Login
            </button>
        </>
    );
}